import { render, staticRenderFns } from "./ticket-user-list.vue?vue&type=template&id=2d001eb4&"
import script from "./ticket-user-list.vue?vue&type=script&lang=js&"
export * from "./ticket-user-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports